import React from 'react';

import PaymentHistoryNotificationsModule from 'partial/OfferManager/modules/PaymentHistoryNotificationsModule';
import PaymentHistorySummaryModule from 'partial/OfferManager/modules/PaymentHistorySummaryModule';
import PaymentHistoryActionsModule from 'partial/OfferManager/modules/PaymentHistoryActionsModule';
import PaymentHistoryResourceModule from 'partial/OfferManager/modules/PaymentHistoryResourceModule';
import TradelineCreditCardsModule from 'partial/OfferManager/modules/TradelineCreditCardsModule';
import TradelineLoansModule from 'partial/OfferManager/modules/TradelineLoansModule';
import FactorTipsOffersModule from 'partial/OfferManager/modules/FactorTipsOffersModule';
import CreditToolsModule from 'partial/OfferManager/modules/CreditToolsModule';
import CreditUsageModule from 'partial/OfferManager/modules/CreditUsageModule';
import CreditUsageTradelinesModule from 'partial/OfferManager/modules/CreditUsageTradelinesModule';
import CreditInquiriesSummaryModule from 'partial/OfferManager/modules/CreditInquiriesSummaryModule';
import HardInquiriesModule from 'partial/OfferManager/modules/HardInquiriesModule';
import CreditAgeSummaryModule from 'partial/OfferManager/modules/CreditAgeSummaryModule';
import AccountMixSummaryModule from 'partial/OfferManager/modules/AccountMixSummaryModule';
import AccountMixAutoLoansTradelinesModule from 'partial/OfferManager/modules/AccountMixAutoLoansTradelinesModule';
import AccountMixHomeLoansTradelinesModule from 'partial/OfferManager/modules/AccountMixHomeLoansTradelinesModule';
import AccountMixStudentLoansTradelinesModule from 'partial/OfferManager/modules/AccountMixStudentLoansTradelinesModule';
import AccountMixRentalsTradelinesModule from 'partial/OfferManager/modules/AccountMixRentalsTradelinesModule';
import AccountMixOtherLoansTradelinesModule from 'partial/OfferManager/modules/AccountMixOtherLoansTradelinesModule';
import FeaturedAdModule from 'partial/OfferManager/modules/FeaturedAd';
import PotentialScoreFactorsModule from 'partial/OfferManager/modules/PotentialScoreFactorsModule';
import FrequentlyAskedQuestionsModule from 'partial/OfferManager/modules/FrequentlyAskedQuestionsModule';
import AccountMixCardsTradelinesModule from 'partial/OfferManager/modules/AccountMixCardsTradelinesModule';
import NativeAdModule from 'partial/OfferManager/modules/NativeAdModule';
import Default from 'partial/OfferManager/modules/Default';
import ReviewEntryPoints from 'partial/OfferManager/modules/ReviewEntryPoints';
import CreditCardDebtPayoff from 'partial/OfferManager/modules/CreditCardDebtPayoff';
import GoToFullCreditReportModule from 'partial/OfferManager/modules/GoToFullCreditReportModule';
import AvailableForYouModule from 'partial/OfferManager/modules/AvailableForYouModule';

const CreditFactorsDashboardModule = props => {
  switch (props?.module) {
    case 'NOTIFICATIONS':
      return <PaymentHistoryNotificationsModule {...props} />;
    case 'NATIVE_ADS':
      return <NativeAdModule {...props} />;
    case 'ACCOUNT_MIX_SUMMARY':
      return <AccountMixSummaryModule {...props} />;
    case 'ACCOUNT_MIX_ACTION':
      return <PaymentHistoryActionsModule {...props} />;
    case 'TRADELINE_CREDIT_CARDS':
      return <TradelineCreditCardsModule {...props} />;
    case 'TRADELINE_AUTO_LOANS':
      return <AccountMixAutoLoansTradelinesModule {...props} />;
    case 'TRADELINE_HOME_LOANS':
      return <AccountMixHomeLoansTradelinesModule {...props} />;
    case 'TRADELINE_STUDENT_LOANS':
      return <AccountMixStudentLoansTradelinesModule {...props} />;
    case 'TRADELINE_RENTALS':
      return <AccountMixRentalsTradelinesModule {...props} />;
    case 'TRADELINE_OTHER_LOANS':
      return <AccountMixOtherLoansTradelinesModule {...props} />;
    case 'FEATURED_AD':
      return <FeaturedAdModule {...props} />;
    case 'PAYMENT_HISTORY_SUMMARY':
      return <PaymentHistorySummaryModule {...props} />;
    case 'PAYMENT_HISTORY_ACTION':
      return <PaymentHistoryActionsModule {...props} />;
    case 'PAYMENT_HISTORY_RESOURCE':
      return <PaymentHistoryResourceModule {...props} />;
    case 'TRADELINE_LOANS':
      return <TradelineLoansModule {...props} />;
    case 'REVIEW_ENTRY_POINTS':
      return <ReviewEntryPoints {...props} />;
    case 'CREDIT_CARD_DEBT_PAYOFF':
      return <CreditCardDebtPayoff {...props} />;
    case 'TRADELINE_ACCOUNT_MIX_CREDIT_CARDS':
      return <AccountMixCardsTradelinesModule {...props} />;
    case 'PAYMENT_HISTORY_OFFERS':
    case 'CREDIT_USAGE_OFFERS':
    case 'CREDIT_AGE_OFFERS':
    case 'ACCOUNT_MIX_OFFERS':
    case 'CREDIT_INQUIRIES_OFFERS':
      return <FactorTipsOffersModule {...props} />;
    case 'CREDIT_TOOLS':
      return <CreditToolsModule className={'m-hide t-hide'} {...props} />;
    case 'CREDIT_USAGE_NOTIFICATIONS':
      return <PaymentHistoryNotificationsModule {...props} />;
    case 'CREDIT_USAGE_SUMMARY':
      return <CreditUsageModule {...props} />;
    case 'TRADELINES_OPEN_CREDIT_CARD_ACCOUNTS':
      return <CreditUsageTradelinesModule {...props} />;
    case 'CREDIT_USAGE_ACTION':
      return <PaymentHistoryActionsModule {...props} />;
    case 'CREDIT_INQUIRIES_SUMMARY':
      return <CreditInquiriesSummaryModule {...props} />;
    case 'HARD_INQUIRIES':
      return <HardInquiriesModule {...props} />;
    case 'CREDIT_AGE_SUMMARY':
      return <CreditAgeSummaryModule {...props} />;
    case 'CREDIT_AGE_ACTION':
      return <PaymentHistoryActionsModule {...props} />;
    case 'POTENTIAL_ALL_BUREAU_SCORES_CREDIT_FACTORS':
      return <PotentialScoreFactorsModule {...props} />;
    case 'FACTORS_FREQUENTLY_ASKED_QUESTIONS':
      return <FrequentlyAskedQuestionsModule {...props} />;
    case 'GO_TO_FULL_CREDIT_REPORT':
      return (
        <GoToFullCreditReportModule className={'d-hide gap-20'} {...props} />
      );
    case 'AVAILABLE_FOR_YOU':
      return <AvailableForYouModule className={'m-hide t-hide'} {...props} />;
    default:
      return <Default {...props} />;
  }
};

export default CreditFactorsDashboardModule;
